<template>
  <Paper class='productProcess defaultClass'>
    <div class='numHead'>
      <div>
        <el-input
            :placeholder="$translate('lang.E3202103030002', { defaultText: '请输入条码号搜索' })"
            @keyup.enter.native='search'
            v-model='proNum'>
        </el-input>
      </div>
      <el-button type='primary' icon='el-icon-search' @click='search' size='mini' class='searchBtn'>
          {{$translate('lang.E3202103030003', { defaultText: '搜 索' })}}
      </el-button>
      <span class='icon font_family close' @click.prevent='delProNum' v-show='hasProNum'>&#xe6a3;</span>
    </div>
    <el-row class='blankArea'>
    </el-row>
    <el-row class='proGo'>
      <el-col :span='20'>
          <span class='proGoText'>{{$translate('lang.E3202103030004', { defaultText: '产品流向' })}}</span>
          <span class='changeText'>{{$translate('lang.E3202103030005', { defaultText: '点击切换查看' })}}</span>
      </el-col>
      <el-col :span='4' style='text-align: right;'>
        <span class='icon font_family homeIcon' :class='[defaultClass? "homeIconDefault": "homeIconSuccess"]'>&#xe6a6;</span>
        <span :class='[defaultClass? "indexPageDefault": "indexPageSuccess"]' @click.prevent='gotoindexPage'>
            {{$translate('lang.E3202103030006', { defaultText: '查看产品信息' })}}
        </span>
      </el-col>
    </el-row>
    <div class='processAll'>
      <div class='processDet' v-for='(item,index) in processArr' :key='index'>
            <div class='processDetTop'>
              <div
              :class='{svgShow: defaultColor, greener: activeCode === index, svgShowSuccess: item.statu === "0", svgShowDefault: item.statu !== "0"}'
              @click.prevent='changeTab(item.code)'>
                <span
                    class='icon font_family'
                    :class="[index === 3? 'transportIcon' : '', item.statu === '0'? 'iconSuccess' : 'iconDefault', activeCode === index? 'iconAct' : '']">
                    {{item.icon}}
                </span>
              </div>
              <div class='lineCrossing' v-if='index < 5' :class="[linedefaultClass? 'lineCrossingDefault' : 'lineCrossingSuccess']"></div>
            </div>
            <div
                class='iconText'
                :class="[index === 4? 'agentText' : '', index === 5? 'clientText' : '', item.statu === '0'? 'iconTextSuccess' : 'iconTextDefault', activeCode === index? 'iconTextAct' : '']"
                @click.prevent='changeTab(item.code)'>{{item.title}}
            </div>
      </div>
    </div>
    <el-row class='blankArea blankAreaLow'>
    </el-row>
    <el-row class='tabContent'>
      <proMessage v-show='activeCode === 6' ref='proMessage' @setIndex='setIndex'></proMessage>
      <make v-show='activeCode === 0' ref='make'></make>
      <unLine v-show='activeCode === 1' ref='unLine'></unLine>
      <check v-show='activeCode === 2' ref='check'></check>
      <transport v-show='activeCode === 3' ref='transport'></transport>
      <agent v-show='activeCode === 4' ref='agent'></agent>
      <client v-show='activeCode === 5' ref='client'></client>
    </el-row>
  </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import Make from './component/make';
import Agent from './component/agent';
import Check from './component/check';
import Client from './component/client';
import Transport from './component/transport';
import UnLine from './component/unLine';
import ProMessage from './component/proMessage';
import { searchNode } from '../../../api/productProcess.js';
export default {
    name: 'productProcess',
    components: {
        Paper, Agent, Make, Check, Client, Transport, UnLine, ProMessage
    },
    data() {
        return {
            hasProNum: false,
            defaultClass: true,
            linedefaultClass: true,
            proNum: '',
            defaultColor: true,
            activeCode: 6,
            flag: false,
            showFlag: false,
            iconArr: [],
            processArr: [{
                title: this.$translate('lang.E3202103030007', { defaultText: '工厂制造' }),
                ref: 'make',
                code: 0,
                icon: '\ue6a2',
                statuLabel: 'manufactureNodeStatus',
                statu: '0' // 判断高亮状态
            }, {
                title: this.$translate('lang.E3202103030008', { defaultText: '成品下线' }),
                ref: 'unLine',
                code: 1,
                icon: '\ue6ac',
                statuLabel: 'offLineNodeStatus',
                statu: '0'
            }, {
                title: this.$translate('lang.E3202103030009', { defaultText: '品质检验' }),
                ref: 'check',
                code: 2,
                icon: '\ue6a5',
                statuLabel: 'checkNodeStatus',
                statu: '0'
            }, {
                title: this.$translate('lang.E3202103030010', { defaultText: '物流运输' }),
                ref: 'transport',
                code: 3,
                icon: '\ue6a8',
                statuLabel: 'transNodeStatus',
                statu: '0'
            }, {
                title: this.$translate('lang.E3202103030011', { defaultText: '渠道销售' }),
                ref: 'agent',
                code: 4,
                icon: '\ue6a1',
                statuLabel: 'agentNodeStatus',
                statu: '0'
            }, {
                title: this.$translate('lang.E3202103030012', { defaultText: '用户服务' }),
                ref: 'client',
                code: 5,
                icon: '\ue6a4',
                statuLabel: 'customerNodeStatus',
                statu: '0'
            }]
        };
    },
    methods: {
        delProNum() {
            this.proNum = '';
        },
        search() {
            this.setIcon();
            this.activeCode = 6;
            this.flag = true;
            if (!this.proNum.trim()) {
                this.processArr.forEach(item => {
                    item.statu = '';
                });
                this.defaultClass = true;
                this.linedefaultClass = true;
                this.$message.warning(this.$translate('lang.EXC202103030001', { defaultText: '请填写条码号再查询!' }));
                this.$refs['proMessage'].setproNum(this.proNum);
            };
            this.processArr.map(item => {
                this.$refs[item.ref].setproNum(this.proNum);
            });
            this.$refs['proMessage'].setproNum(this.proNum);
        },
        changeTab(code) {
            this.activeCode = code;
            switch (code) {
            case 0:
                this.$refs['make'].getMessage();
                break;
            case 1:
                this.$refs['unLine'].getMessage();
                break;
            case 2:
                this.$refs['check'].getMessage();
                break;
            case 3:
                this.$refs['transport'].getMessage();
                break;
            case 4:
                this.$refs['agent'].getMessage();
                break;
            case 5:
                this.$refs['client'].getMessage();
                break;
            default:
                break;
            }
        },
        // 判断首页是否有数据，有数据返回首页的图标文字切换绿色
        setIndex(flag) {
            this.defaultClass = flag;
        },
        // 判断那些图标可点击,切换绿色状态
        setIcon() {
            if (!this.proNum) {
                return;
            }
            this.processArr.forEach(item => {
                item.statu = '';
            });
            this.defaultClass = true;
            this.linedefaultClass = true;
            searchNode(this.proNum).then(res => {
                if (res.code === '0' && res.data) {
                    this.linedefaultClass = false;
                    const data = res.data;
                    Object.keys(data).map(item => {
                        this.processArr.forEach(item2 => {
                            if (item2.statuLabel === item) {
                                item2.statu = data[item];
                            }
                        });
                        return item;
                    });
                }
            }).catch(() => {
                this.linedefaultClass = true;
            });
        },
        // 返回首页
        gotoindexPage() {
            this.activeCode = 6;
            this.$refs['proMessage'].initTabDefault();
        }
    },
    watch: {
        proNum: function(val) {
            if (!val) {
                this.hasProNum = false;
            } else {
                this.hasProNum = true;
            }
        }
    }
};
</script>
<style lang='less'>
@import url('./component/style/index.less');
</style>
